module.exports = __webpack_public_path__ + "img/loading_icon.df944520.svg";